export default {
	id: "light",
	name: "Light",
	colors: {
		"--theme-foreground": "#3A3A3A",
		"--theme-foreground-muted": "#AAA",
		"--theme-foreground-against-accent": "#FFF",
		"--theme-background": "#FFF",
		"--theme-background-muted": "#F2F2F2",
		"--theme-border": "#AAA",
		"--theme-border-muted": "#DDD",
		"--theme-menu-foreground": "#FFF",
		"--theme-menu-background": "#161A1E",
		"--theme-good": "#65C05A",
		"--theme-bad": "#FF5763",
		"--theme-foreground-against-good": "#FFF",
		"--theme-foreground-against-bad": "#FFF",
	}
};